/** A date input's "YYYY-MM-DD" as that day's local midnight, which the API takes as RFC 3339. */
export function startOfLocalDay(date: string): string {
  const [year, month, day] = date.split("-").map(Number);
  return new Date(year ?? NaN, (month ?? NaN) - 1, day ?? NaN).toISOString();
}

/** A Date's own calendar day, local time, in the date input's "YYYY-MM-DD" format. */
export function localDay(when: Date): string {
  const pad = (n: number) => String(n).padStart(2, "0");
  return `${when.getFullYear()}-${pad(when.getMonth() + 1)}-${pad(when.getDate())}`;
}

/** Today takes effect immediately (now); any other date takes effect at its local midnight. */
export function effectiveFromFor(date: string, now: Date = new Date()): string {
  return date === localDay(now) ? now.toISOString() : startOfLocalDay(date);
}
